import React from "react"

function Sidebar () {
  return (
    <div id="sidebar">
      <h2>Most Recent Video</h2>
      <div className="iframe-container">
        <iframe src="https://www.youtube.com/embed/Kzq40NUIuI8" title="Canada's Wonderland in Open RollerCoaster Tycoon 2 in OpenRCT2" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen loading="lazy"></iframe>
      </div>

      <hr />

      <h2>Most Viewed Video</h2>
      <div className="iframe-container">
        <iframe src="https://www.youtube.com/embed/iLRXUIbWp6c" title="Mt.Fire Eyes Found" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen loading="lazy"></iframe>
      </div>
    </div>
  )
}

export default Sidebar